import ModemListContainer from '../../../../components/units/Management/Modem/list/modemListContainer';

export default function ModemListPage() {
  return <ModemListContainer />;
}
